import React from 'react';
const links = [{
  label: 'Conditions',
  href: '#terms'
}, {
  label: 'Politique de confidentialité',
  href: '#privacy'
}, {
  label: 'Politique de remboursement',
  href: '#refund'
}];
export function SiteFooter() {
  return <footer className="bg-brand-charcoal px-5 pb-28 pt-12 text-white/70 md:pb-12 lg:px-8" data-id="element-120" data-mp="35diyughwmpob">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-121" data-mp="3a5su8c1sghxz">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-white" data-id="element-122" data-mp="3f3lxoxbpixuk">
          Makeup Instructor Ready
        </p>
        <nav aria-label="Pied de page" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-123" data-mp="3o4sfd9q3eepe">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60" data-id="element-124" data-mp="3t2txnsfp29zt">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-white/50" data-id="element-125" data-mp="pd9kv1avqbx">
        © 2026 Makeup Instructor Ready. Système de ressources pédagogiques numériques livré en PDF non modifiables. Il
        ne représente ni une licence gouvernementale ni une accréditation externe. Les paiements sont traités dans
        votre devise locale.
      </p>
    </footer>;
}